import { NormalBlend } from "./CommonRenderTargets";

// WebGPU default blend for targets.
/** @type {GPUBlendState} */
const DefaultBlend = {
  color: {
    operation: 'add',
    srcFactor: 'one',
    dstFactor: 'zero'
  },
  alpha: {
    operation: 'add',
    srcFactor: 'one',
    dstFactor: 'zero'
  }
};

/** @returns {GPUBlendState} */
export function getTargetBlendStateFromMaterial(
// blend properties as provided by THREE.Material
{
  blending
  //  blendEquation, blendSrc, blendDst,
  //  blendEquationAlpha, blendSrcAlpha, blendDstAlpha
}) {

  switch (blending) {
    case THREE.NoBlending:
      return DefaultBlend;
    case THREE.NormalBlending:
      return NormalBlend;
    case THREE.AdditiveBlending:
      return {
        color: {
          operation: 'add',
          srcFactor: 'src-alpha',
          dstFactor: 'one'
        },
        alpha: {
          operation: 'add',
          srcFactor: 'src-alpha',
          dstFactor: 'one'
        }
      };
    case THREE.SubtractiveBlending:
      return {
        color: {
          operation: 'add',
          srcFactor: 'zero',
          dstFactor: 'one-minus-src'
        },
        alpha: {
          operation: 'add',
          srcFactor: 'zero',
          dstFactor: 'one-minus-src-alpha'
        }
      };
    case THREE.MultiplyBlending:
      return {
        color: {
          operation: 'add',
          srcFactor: 'zero',
          dstFactor: 'src'
        },
        alpha: {
          operation: 'add',
          srcFactor: 'zero',
          dstFactor: 'src'
        }
      };
    case THREE.CustomBlending:
      console.warn('Custom blending is not yet implemented in WebGPU. Falling back to normal blending.');
      return NormalBlend;
    default:
      console.warn(`Unknown blending mode: ${blending}. Falling back to default blending.:`);
      return DefaultBlend;
  }
};